// File: stacks/workout/app/src/config/targets.js

// Centralized target areas, muscles, and presets.

// Comprehensive list of muscles, grouped by body region for categorized selection.
export const TARGET_MUSCLE_CATEGORIES = {
  Chest: ["Pectoralis Major", "Pectoralis Minor"],
  Back: ["Lats", "Traps", "Rhomboids", "Lower Back", "Teres Major/Minor"],
  Shoulders: [
    "Anterior Deltoid",
    "Lateral Deltoid",
    "Posterior Deltoid",
    "Rotator Cuff",
  ],
  Arms: ["Biceps", "Triceps", "Forearms"],
  Core: ["Abs", "Obliques", "Transverse Abdominis"],
  Legs: ["Quads", "Hamstrings", "Calves", "Adductors", "Abductors"],
  "Glutes & Hips": ["Glutes", "Hip Flexors"],
};

// Quick presets that combine multiple specific muscle groups.
export const TARGET_AREA_PRESETS = {
  "Full Body": [
    "Pectoralis Major",
    "Lats",
    "Anterior Deltoid",
    "Abs",
    "Glutes",
    "Quads",
    "Hamstrings",
  ],
  "Upper Body": [
    "Pectoralis Major",
    "Lats",
    "Traps",
    "Anterior Deltoid",
    "Biceps",
    "Triceps",
  ],
  "Lower Body": ["Glutes", "Quads", "Hamstrings", "Calves", "Hip Flexors"],
  "Core Focus": ["Abs", "Obliques", "Lower Back", "Transverse Abdominis"],
  Push: ["Pectoralis Major", "Anterior Deltoid", "Triceps"],
  Pull: ["Lats", "Traps", "Rhomboids", "Biceps", "Posterior Deltoid"],
  Arms: ["Biceps", "Triceps", "Forearms"],
};

// A flattened, unique, and sorted list of all individual muscles.
const allMusclesSet = new Set();
Object.values(TARGET_MUSCLE_CATEGORIES).forEach((categoryItems) => {
  categoryItems.forEach((item) => allMusclesSet.add(item));
});
export const ALL_TARGET_MUSCLES = Array.from(allMusclesSet).sort();

// Formatted data structure for use in the enhanced Combobox component.
export const TARGET_OPTIONS_WITH_CATEGORIES = Object.entries(
  TARGET_MUSCLE_CATEGORIES
)
  .map(([category, items]) => ({
    label: category,
    options: items.map((item) => ({ value: item, label: item })),
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

// Common areas of injury or limitation for user context.
export const INJURY_AREAS = [
  "Neck",
  "Shoulders",
  "Elbows",
  "Wrists",
  "Upper Back",
  "Lower Back",
  "Hips",
  "Knees",
  "Ankles",
];

export const INJURY_AREA_OPTIONS = INJURY_AREAS.map((area) => ({
  value: area,
  label: area,
}));
